import { motion } from 'motion/react';
import { ElectricParticles } from './ElectricParticles';

export function AuthBackground() {
  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none">
      {/* Gradient base */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#8bc43e]/10 via-background to-background dark:from-[#8bc43e]/5 dark:via-background dark:to-background" />

      {/* Animated drifting orb */}
      <motion.div
        className="absolute -top-1/4 -right-1/4 w-[500px] h-[500px] rounded-full bg-[#8bc43e]/8 dark:bg-[#8bc43e]/5 blur-3xl"
        animate={{
          x: [0, 50, 0],
          y: [0, 30, 0],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      {/* Second smaller orb for depth */}
      <motion.div
        className="absolute -bottom-1/4 -left-1/4 w-[350px] h-[350px] rounded-full bg-[#8bc43e]/6 dark:bg-[#8bc43e]/3 blur-3xl"
        animate={{
          x: [0, -30, 0],
          y: [0, -40, 0],
        }}
        transition={{
          duration: 18,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      {/* Electric particles */}
      <ElectricParticles />
    </div>
  );
}
